import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#475467"
      fillRule="evenodd"
      d="m10.143 11.91-1.91 1.912L9.41 15l3.922-3.923-3.922-3.922-1.179 1.178 1.911 1.911H1.667V0H0v11.077c0 .46.373.834.833.834h9.31Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
